module.exports = __webpack_public_path__ + "img/Freundchen.88c56b66.svg";